import React from 'react';

/**
 * 轻量错误边界：子组件崩溃时不影响兄弟节点（如叠加工具 vs 画板）
 * 崩溃时显示 fallback（可见提示），避免整块工具「无声消失」。
 */
export default class DashboardToolErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[DashboardToolErrorBoundary:${this.props.name || 'tool'}]`, error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}
